import { createSlotRecipe } from './runtime.js';

const tagsInputConfig = {"name":"tagsInput","slots":["control","input","itemPreview","clearTrigger","searchIcon"],"defaultVariants":{"size":"md"},"variantMap":{"size":["lg","md","sm","xl","xs"]}}

export const tagsInput = /* @__PURE__ */ createSlotRecipe(tagsInputConfig)